import axios from 'axios'
import message from 'ant-design-vue/es/message'
import { getOssConfig } from '@/api/system/upload.js'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { guid } from '@/utils/ruoyi.js'

export default class UploadFileToOSS {

    /**
     * [constructor description]
     * @param  {[Array]} files [chooseImg选中的tempFilePaths、chooseVideo选中的rempFilePath]
     * @param  {[Object]} json  [success每上传成功一张调用 complete全部上传完成调用]
     * @return {[void]}       [description]
     */

    constructor(files, json) {
        if (!Array.isArray(files)) {
            throw new Error('Class UploadFileToOSS parameter must be an array');
        }
        console.log('files, json', files, json)
        this.data = [];
        this.fn = json.success;
        this.complete = json.finally;
        this.files = files;
        this.fileLen = this.files.length;
        this.curIndex = 0;
        // message.info({ message: '上传中' })
        this.upload();
    }

    async upload() {
        // 随机生成一个文件名，并且按照日期归类到二级目录下，否则很容易产生覆盖
        const dates = new Date()
        const year = dates.getFullYear()
        const month = dates.getMonth() + 1
        const date = dates.getDate()
        const nowDate = year + '-' + (month < 10 ? `0${month}` : month) + '-' + (date < 10 ? `0${date}` : date)
        console.log('nowDate', nowDate)
        getOssConfig().then(res => {
            let ossData = res.data
            let form = new FormData()
            let fileName = this.files[this.curIndex].name;
            let videoTime = 0;
            if(this.files[0].type.includes('video')){
              let self = this
              new Promise(function(resolve) {
                let video = document.createElement('video')
                video.setAttribute('crossOrigin', 'anonymous') //处理跨域
                video.setAttribute('src', URL.createObjectURL(self.files[self.curIndex]))
                video.currentTime = 1
                video.addEventListener('loadeddata', function() {
                  videoTime = video.duration;
                })
              })
            }
            // if(this.files[0].videoTime){
            //   videoTime = this.files[0].videoTime;
            // }
            let name = this.files[0].type.split("/")[1]
            //console.log('guid(8, 10)', nowDate + '/' + guid(32, 62) + '/')
            form.append('key', `${nowDate}/` + ossData.fileName + '.' + name)
            form.append('policy', ossData.policy)
            form.append('OSSAccessKeyId', ossData.accessid)
            form.append('success_action_status', '200')
            form.append('signature', ossData.signature)
            //console.log('files', this.files)
            form.append('Content-Disposition', 'attachment;filename=' + fileName)
            form.append('file', this.files[this.curIndex])
            const token = storage.get(ACCESS_TOKEN)
            axios({
                url: ossData.endpoint,
                method: 'post',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                    // 'Content-Disposition': 'attachment;filename=' + encodeURIComponent(ossData.fileName)
                },
                data: form,
            }).then(res => {
                console.log('res', res)
                if (res.status === 200) {
                    let url = ossData.resultUrl + `${nowDate}/` + ossData.fileName + '.' + name
                    console.log('url', url)
                    this.data.push({
                        uid: guid(8, 10),
                        name: ossData.fileName + '.' + name,
                        fileName: fileName,
                        videoTime: videoTime,
                        status: 'done',
                        path: url,
                        url: url,
                        cover: ''
                    });
                    if (this.fn) this.fn(this.data);
                } else {
                    message.error('上传失败，请重试')
                }
            }).finally(res => {
                console.log('结束', res)
                if (this.fn) this.fn(this.data);
                this.curIndex++; // 当前文件执行完上传后，开始上传下一张
                if (this.curIndex == this.fileLen) { // 当文件传完时，停止调用
                    this.complete(this.data);
                } else { // 若文件还没有传完，则继续调用函数
                    this.upload();
                }
            })
        })
    }
}